// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"ernestdefoe-bespoke:forum/components/BespokeEditor":"forum/components/BespokeEditor","ernestdefoe-bespoke:forum/packagistIcon":"forum/packagistIcon"}[chunkId] + ".js";
};